// import React, { useState } from "react";
// import { useQuery } from "react-query";
// import { NavLink, useNavigate } from "react-router-dom";
// // import { getDocument } from "../../../Services/Document";
// import DeleteDocument from "./DeleteDocument";
// import { getDocument } from "../../Services/Document";

// const Document = () => {
//   const navigate = useNavigate();

//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [selectedDocumentId, setSelectedDocumentId] = useState(null);

//   const {
//     data: documentResponse,
//     isLoading,
//     isError,
//     refetch,
//   } = useQuery("get-document", getDocument);

//   const documentData = documentResponse?.data?.data || [];

//   const formatDate = (date) => {
//     if (!date) return "-";

//     return new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   if (isLoading) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-gray-500">Loading Documents...</p>
//       </div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-red-500">Failed to load Documents.</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="mx-auto max-w-8xl p-3">
//         {/* HEADER */}
//         <div className="mb-4 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
//           <div>
//             <h1 className="text-2xl font-semibold text-gray-800">Documents</h1>

//             <p className="mt-1 text-sm text-gray-500">Manage your documents.</p>
//           </div>

//           <NavLink
//             to="/document/add"
//             className="rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-blue-700"
//           >
//             + Add Document
//           </NavLink>
//         </div>

//         {/* TABLE */}
//         <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//           <div className="border-b border-gray-200 px-4 py-3">
//             <h2 className="font-semibold text-gray-800">Document List</h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[1200px] text-left">
//               <thead className="bg-gray-50">
//                 <tr className="border-b border-gray-200">
//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     ID
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Slug
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Excerpt
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Category
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Status
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Cover Image
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Published At
//                   </th>

//                   <th className="px-5 py-3 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Action
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {documentData.length > 0 ? (
//                   documentData.map((item) => (
//                     <tr
//                       key={item.id}
//                       className="border-b border-gray-100 transition hover:bg-gray-50"
//                     >
//                       {/* ID */}
//                       <td className="px-5 py-3">
//                         <span className="font-semibold text-gray-700">
//                           #{item.id}
//                         </span>
//                       </td>

//                       {/* SLUG */}
//                       <td className="px-5 py-3">
//                         <span className="font-medium text-gray-800">
//                           {item.slug || "-"}
//                         </span>
//                       </td>

//                       {/* EXCERPT */}
//                       <td className="max-w-[250px] px-5 py-3">
//                         <p className="line-clamp-2 text-sm text-gray-600">
//                           {item.excerpt || "-"}
//                         </p>
//                       </td>

//                       {/* CATEGORY */}
//                       <td className="px-5 py-3">
//                         <span className="rounded-full bg-purple-50 px-3 py-1 text-xs font-medium text-purple-700">
//                           {item.category || "-"}
//                         </span>
//                       </td>

//                       {/* STATUS */}
//                       <td className="px-5 py-3">
//                         <span
//                           className={`rounded-full px-3 py-1 text-xs font-semibold ${
//                             String(item.status).toLowerCase() === "published"
//                               ? "bg-green-50 text-green-700"
//                               : "bg-yellow-50 text-yellow-700"
//                           }`}
//                         >
//                           {item.status || "-"}
//                         </span>
//                       </td>

//                       {/* COVER IMAGE */}
//                       <td className="px-5 py-3">
//                         {item.cover_image ? (
//                           <img
//                             src={item.cover_image}
//                             alt="Cover"
//                             className="h-12 w-16 rounded-lg object-cover"
//                           />
//                         ) : (
//                           <span className="text-sm text-gray-400">
//                             No Image
//                           </span>
//                         )}
//                       </td>

//                       {/* PUBLISHED */}
//                       <td className="px-5 py-3 text-sm text-gray-600">
//                         {formatDate(item.published_at)}
//                       </td>

//                       {/* ACTION */}
//                       <td className="px-5 py-3">
//                         <div className="flex items-center justify-center gap-2">
//                           <button
//                             type="button"
//                             onClick={() =>
//                               navigate(`/document/${item.id}`, {
//                                 state: {
//                                   documentData: item,
//                                 },
//                               })
//                             }
//                             className="rounded-lg border border-blue-200 px-3 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50"
//                           >
//                             Edit
//                           </button>

//                           <button
//                             type="button"
//                             onClick={() => {
//                               setSelectedDocumentId(item.id);
//                               setDeleteModalOpen(true);
//                             }}
//                             className="rounded-lg border border-red-200 px-3 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="8"
//                       className="px-5 py-12 text-center text-sm text-gray-500"
//                     >
//                       No documents found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <DeleteDocument
//         open={deleteModalOpen}
//         document_id={selectedDocumentId}
//         onClose={() => {
//           setDeleteModalOpen(false);
//           setSelectedDocumentId(null);
//         }}
//         onSuccess={() => {
//           setDeleteModalOpen(false);
//           setSelectedDocumentId(null);
//           refetch();
//         }}
//       />
//     </>
//   );
// };

// export default Document;
// import React, { useState } from "react";
// import { useQuery } from "react-query";
// import { NavLink, useNavigate } from "react-router-dom";
// import DeleteDocument from "./DeleteDocument";
// import { getDocument } from "../../Services/Document";

// const Document = () => {
//   const navigate = useNavigate();

//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [selectedDocumentId, setSelectedDocumentId] = useState(null);

//   const {
//     data: documentResponse,
//     isLoading,
//     isError,
//     refetch,
//   } = useQuery("get-document", getDocument);

//   const documentData = documentResponse?.data?.data || [];

//   const formatDate = (date) => {
//     if (!date) return "-";

//     const parsedDate = new Date(date);

//     if (Number.isNaN(parsedDate.getTime())) {
//       return "-";
//     }

//     return parsedDate.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const getDocumentId = (item) => {
//     return item?.document_id || item?.id || null;
//   };

//   if (isLoading) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-gray-500">Loading Documents...</p>
//       </div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-red-500">Failed to load Documents.</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="mx-auto max-w-8xl p-3">
//         {/* HEADER */}
//         <div className="mb-4 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
//           <div>
//             <h1 className="text-2xl font-semibold text-gray-800">Documents</h1>

//             <p className="mt-1 text-sm text-gray-500">Manage your documents.</p>
//           </div>

//           <NavLink
//             to="/document/add"
//             className="rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-blue-700"
//           >
//             + Add Document
//           </NavLink>
//         </div>

//         {/* TABLE */}
//         <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//           <div className="border-b border-gray-200 px-4 py-3">
//             <h2 className="font-semibold text-gray-800">Document List</h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[1200px] text-left">
//               <thead className="bg-gray-50">
//                 <tr className="border-b border-gray-200">
//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     ID
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Slug
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Excerpt
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Category
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Status
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Cover Image
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Published At
//                   </th>

//                   <th className="px-5 py-3 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Action
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {documentData.length > 0 ? (
//                   documentData.map((item) => {
//                     const documentId = getDocumentId(item);

//                     return (
//                       <tr
//                         key={documentId}
//                         className="border-b border-gray-100 transition hover:bg-gray-50"
//                       >
//                         {/* ID */}
//                         <td className="px-5 py-3">
//                           <span className="break-all font-semibold text-gray-700">
//                             {documentId || "-"}
//                           </span>
//                         </td>

//                         {/* SLUG */}
//                         <td className="px-5 py-3">
//                           <span className="font-medium text-gray-800">
//                             {item?.slug || "-"}
//                           </span>
//                         </td>

//                         {/* EXCERPT */}
//                         <td className="max-w-[250px] px-5 py-3">
//                           <p className="line-clamp-2 text-sm text-gray-600">
//                             {item?.excerpt || "-"}
//                           </p>
//                         </td>

//                         {/* CATEGORY */}
//                         <td className="px-5 py-3">
//                           <span className="rounded-full bg-purple-50 px-3 py-1 text-xs font-medium text-purple-700">
//                             {item?.category || "-"}
//                           </span>
//                         </td>

//                         {/* STATUS */}
//                         <td className="px-5 py-3">
//                           <span
//                             className={`rounded-full px-3 py-1 text-xs font-semibold ${
//                               String(item?.status || "").toLowerCase() ===
//                               "published"
//                                 ? "bg-green-50 text-green-700"
//                                 : "bg-yellow-50 text-yellow-700"
//                             }`}
//                           >
//                             {item?.status || "-"}
//                           </span>
//                         </td>

//                         {/* COVER IMAGE */}

//                         {/*
//                         <td className="px-5 py-3">
//                           {item?.cover_image ? (
//                             <img
//                               src={item.cover_image}
//                               alt="Cover"
//                               className="h-12 w-16 rounded-lg object-cover"
//                             />
//                           ) : (
//                             <span className="text-sm text-gray-400">
//                               No Image
//                             </span>
//                           )}
//                         </td>
//                         */}

//                         <td className="px-5 py-3">
//                           <span className="text-sm text-gray-400">
//                             {item?.cover_image ? "Image Available" : "No Image"}
//                           </span>
//                         </td>

//                         {/* PUBLISHED AT */}
//                         <td className="px-5 py-3 text-sm text-gray-600">
//                           {formatDate(item?.published_at)}
//                         </td>

//                         {/* ACTION */}
//                         <td className="px-5 py-3">
//                           <div className="flex items-center justify-center gap-2">
//                             {/* EDIT */}
//                             <button
//                               type="button"
//                               disabled={!documentId}
//                               onClick={() => {
//                                 if (!documentId) return;

//                                 navigate(`/document/${documentId}`, {
//                                   state: {
//                                     documentData: item,
//                                   },
//                                 });
//                               }}
//                               className="rounded-lg border border-blue-200 px-3 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
//                             >
//                               Edit
//                             </button>

//                             {/* DELETE */}
//                             <button
//                               type="button"
//                               disabled={!documentId}
//                               onClick={() => {
//                                 if (!documentId) return;

//                                 setSelectedDocumentId(documentId);
//                                 setDeleteModalOpen(true);
//                               }}
//                               className="rounded-lg border border-red-200 px-3 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
//                             >
//                               Delete
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="8"
//                       className="px-5 py-12 text-center text-sm text-gray-500"
//                     >
//                       No documents found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* DELETE MODAL */}
//       <DeleteDocument
//         open={deleteModalOpen}
//         document_id={selectedDocumentId}
//         onClose={() => {
//           setDeleteModalOpen(false);
//           setSelectedDocumentId(null);
//         }}
//         onSuccess={() => {
//           setDeleteModalOpen(false);
//           setSelectedDocumentId(null);
//           refetch();
//         }}
//       />
//     </>
//   );
// };

// export default Document;

import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { NavLink, useNavigate } from "react-router-dom";

import DeleteDocument from "./DeleteDocument";
import { getDocument, patchDocument } from "../../Services/Document";
import axios from "axios";
import { baseUrl } from "../../Config/baseUrl";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material";

const Document = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [page_data, setPageData] = useState([]);
  const [search, setSearch] = useState("");

  const {
    data: documentResponse,
    isLoading,
    isError,
    refetch,
  } = useQuery(["get-document", page, search], () =>
    getDocument({ page, search }),
  );

  // API response:
  // response.data.data
  //   const documentData = Array.isArray(documentResponse?.data?.data)
  //     ? documentResponse.data.data
  //     : [];
  const documentData = documentResponse?.data?.data || [];

  // GET DOCUMENT ID
  const getDocumentId = (item) => {
    if (!item) return null;

    // UUID ko string hi rakhenge.
    // Number() bilkul nahi karna.
    return item.document_id || item.id || null;
  };

  // FORMAT DATE
  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // EDIT DOCUMENT
  const handleEdit = (item) => {
    const documentId = getDocumentId(item);

    if (!documentId) {
      console.error("Document ID not found:", item);
      return;
    }

    console.log("EDIT DOCUMENT ID:", documentId);
    console.log("EDIT DOCUMENT DATA:", item);

    navigate(`/document/${documentId}`, {
      state: {
        documentData: item,
        document_id: documentId,
      },
    });
  };

  // DELETE DOCUMENT
  const handleDelete = (item) => {
    setSelectedDocumentId(item);
    setDeleteModalOpen(true);
  };

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setPageData(res.data?.data);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getCreer();
  }, []);

  const { mutate: EditDocument } = useMutation(patchDocument, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  // LOADING
  // if (isLoading) {
  //   return (
  //     <div className="flex min-h-[300px] items-center justify-center">
  //       <p className="text-gray-500">Loading Documents...</p>
  //     </div>
  //   );
  // }

  //  ERROR
  if (isError) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <p className="text-red-500">Failed to load Documents.</p>
      </div>
    );
  }

  return (
    <>
      <div className="mx-auto max-w-8xl p-3">
        {/*HEADER*/}
        <div className="mb-4 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
          {/* ADD DOCUMENT */}

          <div className="relative w-full max-w-sm">
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm 
                 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
          </div>
          <NavLink
            to="/document/add"
            className="rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-blue-700"
          >
            + Add Document
          </NavLink>
        </div>

        {/* TABLE */}
        <div className="overflow-hidden rounded-xl bg-white shadow-sm">
          <div className="border-b border-gray-200 px-4 py-3">
            <h2 className="font-semibold text-gray-800">Document List</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full  text-center">
              <thead className="bg-gray-50">
                <tr className="border-b border-gray-200">
                  <th className="px-5 py-3 text-xs font-semibold uppercase  text-gray-500">
                    S.No.
                  </th>

                  <th className="px-5 py-3 text-xs font-semibold uppercase  text-gray-500">
                    Title
                  </th>

                  <th className="px-5 py-3 text-xs font-semibold uppercase  text-gray-500">
                    Category
                  </th>

                  <th className="px-5 py-3 text-xs font-semibold uppercase  text-gray-500">
                    Page
                  </th>

                  <th className="px-5 py-3 text-center text-xs font-semibold uppercase  text-gray-500">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {documentData.length > 0 ? (
                  documentData?.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className="border-b border-gray-100 transition hover:bg-gray-50"
                      >
                        <td className="px-5 py-3">{index + 1}</td>

                        <td className=" px-5 py-3">
                          <p className="truncate w-52 text-sm text-gray-600">
                            {item?.title || "-"}
                          </p>
                        </td>

                        <td className="px-5 py-3">
                          <span className="rounded-full bg-purple-50 px-3 py-1 text-xs font-medium text-purple-700">
                            {item?.category || "-"}
                          </span>
                        </td>

                        <td className="px-5 py-3">
                          <select
                            style={{
                              width: "50%",
                              boxSizing: "border-box",
                              padding: "9px 11px",
                              borderRadius: 8,
                              border: "1px solid #DEDCD1",
                              fontSize: 14,
                              fontFamily: "'IBM Plex Sans', sans-serif",
                              color: "#20201C",
                              background: "#FFFFFF",
                              outline: "none",
                            }}
                            value={item?.page_title}
                            onChange={(e) =>
                              EditDocument({
                                doc_id: item?.id,
                                page_title: e.target.value,
                              })
                            }
                          >
                            <option className="font-bold ">
                              Select A Page
                            </option>
                            {page_data?.map((i) => (
                              <option value={i?.id}>{i?.name}</option>
                            ))}
                          </select>
                        </td>

                        <td className="px-5 py-3">
                          <div className="flex items-center justify-center gap-2">
                            <button
                              type="button"
                              onClick={() =>
                                navigate(`/document/copy`, {
                                  state: item?.id,
                                })
                              }
                              className="rounded-lg border border-green-200 px-3 py-2 text-sm font-semibold text-green-600 transition hover:bg-green-50 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                              Copy
                            </button>

                            <button
                              type="button"
                              onClick={() =>
                                navigate(`/document/update`, {
                                  state: item?.id,
                                })
                              }
                              className="rounded-lg border border-blue-200 px-3 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                              Edit
                            </button>

                            <button
                              type="button"
                              onClick={() => handleDelete(item)}
                              className="rounded-lg border border-red-200 px-3 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="px-5 py-12 text-center text-sm text-gray-500"
                    >
                      No documents found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="p-2 flex items-center  justify-center">
              <Pagination
                page={documentResponse?.data?.current_page ?? 1}
                count={documentResponse?.data?.total_pages ?? 1}
                onChange={(_, value) => setPage(value)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* =========================
          DELETE MODAL
      ========================= */}
      <DeleteDocument
        open={deleteModalOpen}
        document_id={selectedDocumentId}
        onClose={() => {
          setDeleteModalOpen(false);
          setSelectedDocumentId(null);
        }}
        onSuccess={() => {
          setDeleteModalOpen(false);
          setSelectedDocumentId(null);
          refetch();
        }}
      />
    </>
  );
};

export default Document;
